/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-23 14:49:19
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import { SubmissionError } from 'redux-form';
import { fakedData } from './index';

class TagHelper {
  /**
   * Init values from first loading
   *
   * @param  {object} filterOption  filter option value
   * @param  {object} initialValue default values
   *
   * @return {object}               init values
   */
  static initialValues = (filterOption: Object, initialValue: Object) => {
    const {
      displayType,
      swatchStyle = 'circle-grid',
      manualValues,
      valueType,
      selectType,
      prefix,
      useAndCondition,
      excludedValues
    } = filterOption;

    let tagManualValues = [];
    let tagExcludedValues = [];
    if (valueType === 'specific') {
      tagManualValues = manualValues
        ? manualValues.map(item => ({
            value: item,
            label: item
          }))
        : [];
    } else {
      tagExcludedValues = excludedValues
        ? excludedValues.map(item => ({
            value: item,
            label: item
          }))
        : [];
    }

    const result = {
      ...initialValue,
      tagDisplayType: displayType,
      tagSwatchStyle: swatchStyle,
      tagOptionSelect: selectType,
      tagOptionValues: valueType,
      tagManualValues,
      tagPrefix: prefix ? true : false,
      tagPrefixValue: prefix,
      useAndCondition,
      tagExcludedValues
    };

    return result;
  };

  /**
   * Build filter option data based on input values
   *
   * @param  {object} filterOption    input values
   * @param  {object} defaultValues   default values
   *
   * @return {object}                 filter option values
   */
  static buildFilterOptionValues = (filterOption: Object, defaultValues: Object) => {
    const {
      tagDisplayType,
      tagSwatchStyle,
      tagOptionSelect,
      tagOptionValues,
      tagManualValues,
      tagPrefix,
      tagPrefixValue,
      useAndCondition,
      tagExcludedValues
    } = filterOption;

    let manualValues = null;
    let excludedValues = null;
    if (tagOptionValues === 'specific') {
      manualValues = tagManualValues ? tagManualValues.map(item => item.value) : null;
    } else {
      excludedValues = tagExcludedValues ? tagExcludedValues.map(item => item.value) : null;
    }

    const result = {
      ...defaultValues,
      displayType: tagDisplayType,
      swatchStyle: tagSwatchStyle,
      selectType: tagOptionSelect,
      valueType: tagOptionValues,
      manualValues,
      prefix: tagPrefix ? tagPrefixValue : null,
      useAndCondition,
      removeTextFilterValues: '',
      replaceTextFilterValues: null,
      excludedValues
    };

    return result;
  };

  /**
   * Validate for tag
   *
   * @param  {object} filterOption
   * @param  {I18n} i18n
   *
   * @return {boolean/error} void if well validated, throw error if have
   */
  static validateFilterOption = (filterOption: Object, i18n: Object) => {
    // Check manual value
    if (filterOption.tagOptionValues === 'specific') {
      if (_.isEmpty(filterOption.tagManualValues)) {
        throw new SubmissionError({
          tagManualValues: i18n.translate(
            'AdminHTML.FilterTree.Helper.tagHelper_ValidateFilterOption_SubmissionError'
          )
        });
      }
    }
  };

  /**
   * Fake product data for tag
   *
   * @param  {object} filterOption
   * @return {array}              list of product count
   */
  static fakeProductValues = (filterOption: Object) => {
    let values = fakedData(filterOption, 'tags');
    return values;
  };
}

export default TagHelper;
